
import React, { useState } from 'react';

const SIZE = 11;
const Maze: React.FC = () => {
  const [pos, setPos] = useState({ x: 1, y: 1 });
  // Simplified maze structure (1: Wall, 0: Path)
  const maze = [
    [1,1,1,1,1,1,1,1,1,1,1],
    [1,0,0,0,1,0,0,0,0,0,1],
    [1,1,1,0,1,0,1,1,1,0,1],
    [1,0,0,0,0,0,1,0,0,0,1],
    [1,0,1,1,1,1,1,0,1,1,1],
    [1,0,0,0,0,0,0,0,0,0,1],
    [1,1,1,1,1,0,1,1,1,0,1],
    [1,0,0,0,1,0,0,0,1,0,1],
    [1,0,1,0,1,1,1,0,1,0,1],
    [1,0,0,0,0,0,1,0,0,0,1],
    [1,1,1,1,1,1,1,1,1,1,1],
  ];

  const move = (dx: number, dy: number) => {
    const nx = pos.x + dx;
    const ny = pos.y + dy;
    if (maze[ny][nx] === 0) setPos({ x: nx, y: ny });
  };

  return (
    <div className="flex flex-col items-center">
      <div className="grid grid-cols-11 bg-slate-800 p-2 rounded-xl border-4 border-slate-900">
        {maze.map((row, y) => row.map((cell, x) => (
          <div key={`${x}-${y}`} className={`w-8 h-8 ${cell === 1 ? 'bg-slate-900' : 'bg-slate-700'} relative`}>
            {pos.x === x && pos.y === y && <div className="absolute inset-2 bg-blue-500 rounded-full shadow-[0_0_10px_blue]" />}
            {x === 9 && y === 9 && <div className="absolute inset-2 bg-green-500 rounded-full opacity-50" />}
          </div>
        )))}
      </div>
      <div className="mt-8 grid grid-cols-3 gap-2">
        <div/><button onClick={()=>move(0,-1)} className="p-4 bg-slate-700 rounded-xl">↑</button><div/>
        <button onClick={()=>move(-1,0)} className="p-4 bg-slate-700 rounded-xl">←</button>
        <button onClick={()=>move(0,1)} className="p-4 bg-slate-700 rounded-xl">↓</button>
        <button onClick={()=>move(1,0)} className="p-4 bg-slate-700 rounded-xl">→</button>
      </div>
    </div>
  );
};

export default Maze;
